import { BikeleasingContractDetailsDTOStatusEnum } from 'probonio-shared-ui/api';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ExternalLinkButton } from '../../../../component/button/ExternalLinkButton';
import { useBikeleasingPortalLinkBuilder } from '../bikeleasingPortalLink';

const RequestEarlyBuyoutOfferButton: React.FC<{ contractId: string }> = ({ contractId }) => {
  const { t } = useTranslation('extensions');
  const buildBikeleasingPortalLink = useBikeleasingPortalLinkBuilder();

  return (
    <ExternalLinkButton href={buildBikeleasingPortalLink(`/user/contracts/${contractId}?REQUEST_BUYOUT_OFFER=true`)}>
      {t('bikeleasing_v2.contract.requestEarlyBuyoutOffer')}
    </ExternalLinkButton>
  );
};

const ReportBikeDamageButton: React.FC<{ contractId: string }> = ({ contractId }) => {
  const { t } = useTranslation('extensions');
  const buildBikeleasingPortalLink = useBikeleasingPortalLinkBuilder();

  return (
    <ExternalLinkButton href={buildBikeleasingPortalLink(`/user/report-damage/${contractId}`)}>
      {t('bikeleasing_v2.contract.reportBikeDamage')}
    </ExternalLinkButton>
  );
};
const CreateInsuranceClaimButton: React.FC<{ contractId: string }> = ({ contractId }) => {
  const { t } = useTranslation('extensions');
  const buildBikeleasingPortalLink = useBikeleasingPortalLinkBuilder();

  return (
    <ExternalLinkButton href={buildBikeleasingPortalLink(`/user/employer/insurance/create/${contractId}`)}>
      {t('extensions:bikeleasing_v2.contract.claimInsuranceCase')}
    </ExternalLinkButton>
  );
};

const SignContractButton: React.FC<{ contractId: string }> = ({ contractId }) => {
  const { t } = useTranslation('extensions');
  const buildBikeleasingPortalLink = useBikeleasingPortalLinkBuilder();

  return (
    <ExternalLinkButton href={buildBikeleasingPortalLink(`/user/contracts/${contractId}?EMPLOYER_SIGN_CONTRACT=true`)}>
      {t('extensions:bikeleasing_v2.contract.signContract')}
    </ExternalLinkButton>
  );
};

const ApproveRejectButton: React.FC<{ contractId: string }> = ({ contractId }) => {
  const { t } = useTranslation('extensions');
  const buildBikeleasingPortalLink = useBikeleasingPortalLinkBuilder();

  return (
    <ExternalLinkButton href={buildBikeleasingPortalLink(`/user/contracts/${contractId}?EMPLOYER_SHOW_APPROVE_REJECT=true`)}>
      {t('extensions:bikeleasing_v2.contract.approveReject')}
    </ExternalLinkButton>
  );
};

export function useContractButtonsForStatus(
  contractId: string,
  status?: BikeleasingContractDetailsDTOStatusEnum,
  isCompanyOrDealerBike?: boolean,
) {
  switch (status) {
    case BikeleasingContractDetailsDTOStatusEnum.Active:
    case BikeleasingContractDetailsDTOStatusEnum.Expiring:
      return (
        <>
          <CreateInsuranceClaimButton contractId={contractId} />
          {isCompanyOrDealerBike && <ReportBikeDamageButton contractId={contractId} />}
          <RequestEarlyBuyoutOfferButton contractId={contractId} />
        </>
      );
    case BikeleasingContractDetailsDTOStatusEnum.EmployerApprovalRequired:
      return (
        <>
          <ApproveRejectButton contractId={contractId} />
          <SignContractButton contractId={contractId} />
        </>
      );
    default:
      return null;
  }
}
